import { useMutation, useQueryClient } from '@tanstack/react-query';
import { deleteInstagramDisconnect } from '@/services/instagram.service';
import { queryKeys } from '@/hooks/queries/keys';

export const useInstagramDisconnect = () => {
    const queryClient = useQueryClient();
    return useMutation<void, unknown, void>({
        mutationFn: deleteInstagramDisconnect,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: queryKeys.instagram.all });
            queryClient.invalidateQueries({ queryKey: queryKeys.dmAutomation.all });
        },
    });
};
